module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMZJREFUeNpiZEADp06dEgBSCUAcD8QGaNIXgHghEC8wMzP7gCzBiGZIAJCaD8QCDPgByJBEoGEbMAwCGpIANYQUADJsAdwgqEvWM5AHAkEuY4SGyX0k7zQCJRrQvAzi1+PxpiITNGBxhgnUInwAHDkgF53HEjukggtMVDAEBAxYsAhihBExYcVErJWEwgoURv+p4DXiXUQosEkKIzxhtZBkF2EJK1CCXECNMAJnEUrDCF4CkGvQB6hLFsAEWEiNHVwFG0CAAQBFBUp/ZV4HWwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/internotic.png
// module id = l7z9
// module chunks = 1